<div class="filter-for-list">
  <h3 class="alarm-project-name">{{'NOTATIONS_SUB_TITLE' | translate}}</h3>
  <button type="button" class="btn top-list-tools" placement="left" [ngbTooltip]="'NOTATIONS_ADD_TOOLTIP' | translate"
          (click)="openNotationModal()">
    <fa-icon [icon]="iconService.faPlus"></fa-icon>
    {{ 'NOTATIONS_ADD' | translate }}
  </button>
  <app-project-sub-menu></app-project-sub-menu>
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>


<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%">
  {{matTableDataSource}}

  <ng-container matColumnDef="noted_at">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NOTATIONS_DATE_PROJECT_INIT'|translate}}</th>
    <td mat-cell *matCellDef="let note"> {{formatDate(note.noted_at)}}</td>
  </ng-container>

  <ng-container matColumnDef="noted_changed_at">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NOTATIONS_DATE_PROJECT_CHNG'|translate}}</th>
    <td mat-cell *matCellDef="let note"> {{formatDate(note.noted_changed_at)}}</td>
  </ng-container>

  <ng-container matColumnDef="noted_updated_at">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NOTATIONS_DATE_EDIT'|translate}}</th>
    <td mat-cell *matCellDef="let note"> {{formatDate(note.noted_updated_at)}}</td>
  </ng-container>

  <ng-container matColumnDef="note_litteral">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NOTATIONS_NOTE'|translate}}</th>
    <td mat-cell *matCellDef="let note">
      <span class="note-circle"
            [ngStyle]="{backgroundColor: note.note_color}">{{note.note_litteral}}</span>
    </td>
  </ng-container>


  <ng-container matColumnDef="note_justification">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NOTATIONS_JUSTIFICATION'|translate}}</th>
    <td mat-cell *matCellDef="let note"> {{note.note_justification}}</td>
  </ng-container>


  <ng-container matColumnDef="note_user_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NOTATIONS_USER'|translate}}</th>
    <td mat-cell *matCellDef="let note"> {{note.note_user_name}}</td>
  </ng-container>


  <ng-container matColumnDef="note_action">
    <th mat-header-cell *matHeaderCellDef mat-sort-header width="202px">{{'NOTATIONS_ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let note">
      <div class="d-flex">
        <button (click)="openNotationModal(note.id, note.noted_at, note.note_justification, 'read')"
                class="btn list-tools" [ngbTooltip]="'READ_ICON_TOOLTIP' | translate" placement="left">
          <fa-icon [icon]="iconService.faEye"></fa-icon>
        </button>
        <button (click)="openNotationModal(note.id, note.noted_at, note.note_justification)" class="btn list-tools"
                [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate" placement="left">
          <fa-icon [icon]="iconService.faEdit"></fa-icon>
        </button>
        <button (click)="deleteNote(note.id)" class="btn list-tools" [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate"
                style="background-color: red" placement="left">
          <fa-icon [icon]="iconService.faTrashAlt"></fa-icon>
        </button>
      </div>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>
